import {Component, EventEmitter, Output} from '@angular/core';
import {ProductionBatch} from "../../../model";
import {ProductionBatchState} from "../../../store/batch/batch.state";
import {Observable, of, tap} from "rxjs";
import {ModalButtonOptions} from "ng-zorro-antd/modal";

@Component({
    selector: 'app-po-attach-dialog',
    templateUrl: './po-attach-dialog.component.html',
    styleUrls: ['./po-attach-dialog.component.scss'],
    standalone: false
})
export class PoAttachDialogComponent {
  @Output()
  onCancel = new EventEmitter<void>();

  @Output()
  onSelect = new EventEmitter<[string, ProductionBatch]>();

  @Output()
  onBypass = new EventEmitter<ProductionBatch>();

  isVisible: boolean = false;
  selection?: ProductionBatch = undefined;
  options$: Observable<ProductionBatch[]> = of([]);
  batch: ProductionBatch | undefined;

  color: string = "";

  footer: ModalButtonOptions[] = [
    {
      label: $localize`Attach`,
      type: "primary",
      onClick: () => this.onOk()
    },
    {
      label: $localize`Bypass`,
      onClick: () => this.bypass()
    },
  ]

  constructor(
    public state: ProductionBatchState
  ) {
  }

  public show(b: ProductionBatch) {
    this.batch = b;
    this.isVisible = true;
    this.options$ = this.state.getAttachTargets(b.id).pipe(
      tap(ts => {
        // auto initialize selection to first in the list
        if (ts?.length == 1 && !this.selection)
          [this.selection] = ts
      })
    );


    this.color = [...Array(26).keys()]
      .map(x => String.fromCharCode('a'.charCodeAt(0) + x))
      .filter(c => (b.color as any)[c])
      .map(c => c.toUpperCase() + ": " + (b.color as any)[c])
      .join(", ")
  }

  onOk() {
    this.onSelect.emit([this.batch?.id!, this.selection!]);
    this.isVisible = false;
  }

  cancel() {
    this.onCancel.emit();
    this.isVisible = false;
  }


  bypass() {
    this.onBypass.emit(this.batch);
    this.isVisible = false;
  }

  compareFn = (o1: ProductionBatch, o2: ProductionBatch): boolean => (o1 && o2 ? o1.id === o2.id : o1 === o2);
}
